module.exports = __webpack_public_path__ + "media/images/logo-compleet-db6f18877e2607e3a87455cac033e04b.png";